module.exports = __webpack_public_path__ + "static/three-user-avatar-icon-fb6e143d62b568d3eefd3e914c269948.svg";